export default __webpack_public_path__ + "static/media/DOT.1eaa13aa.jpg";